import { useCreateStressAssessment } from './hooks';
import { CreateStressAssessmentPresentation } from './presentations';

export const CreateStressAssessment: React.FC = () => {
  const {
    state: { userCount, isButtonDisabled },
    actions: { onDeadlineChange, onSubmit, onBack },
  } = useCreateStressAssessment();

  if (userCount === undefined) return null;

  return (
    <CreateStressAssessmentPresentation
      userCount={userCount}
      onDeadlineChange={onDeadlineChange}
      onSubmit={onSubmit}
      onBack={onBack}
      isButtonDisabled={isButtonDisabled}
    />
  );
};
